
    import './styles.scoped.css';
    export default {
  "button": "awsui_button_m5h9f_yca2g_3",
  "expanded": "awsui_expanded_m5h9f_yca2g_32",
  "padding-right-l": "awsui_padding-right-l_m5h9f_yca2g_43",
  "padding-right-xxl": "awsui_padding-right-xxl_m5h9f_yca2g_46",
  "text": "awsui_text_m5h9f_yca2g_68",
  "icon": "awsui_icon_m5h9f_yca2g_72"
};
  